import isEmail from 'validator/lib/isEmail';
import User from '../../../resources/scripts/features/user-manager';

class BrixResetPasswordForm {
  static init(...parameters) {
    return new BrixResetPasswordForm(...parameters);
  }

  constructor(block) {
    this.block = block;
    this.form = block.querySelector('form');
    this.submittedElement = block.querySelector('.submitted');
    this.contentElements = block.querySelectorAll('.content-text');
    this.afterResetText = block.querySelector('.content-text.after-reset');
    this.emailInput = this.form.querySelector('input[type=email]');
    this.emailInputErrorMsg = this.form.querySelector('.email-field-error');
    this.submitButton = this.form.querySelector('.submit');
    this.generalErrorMsg = this.form.querySelector('.error-message');
    this.tokenUrl = this.form.dataset.tokenPage;

    this.submitButton.addEventListener('click', (event) => {
      this.resetPasswordEventHandler(event);
    });
  }

  async resetPasswordEventHandler(event) {
    event.preventDefault();

    if (!this.tokenUrl) {
      this.emailInput.parentElement.classList.remove('-error');
      this.generalErrorMsg.innerText = this.generalErrorMsg.dataset.somethingWentWrong;
      this.generalErrorMsg.classList.add('-visible');
      return;
    }

    if (this.emailInput.value === '' || !isEmail(this.emailInput.value)) {
      this.emailInput.parentElement.classList.add('-error');
      this.generalErrorMsg.classList.remove('-visible');
      return;
    }

    this.emailInput.parentElement.classList.remove('-error');
    this.generalErrorMsg.classList.remove('-visible');

    await User.resetPassword({
      email: this.emailInput.value.toLowerCase(),
      url: this.tokenUrl,
    });

    this.form.style.display = 'none';
    this.submittedElement.style.display = 'flex';

    [].forEach.call(this.contentElements || [], (item) => {
      item.style.display = 'none';
    });
    this.afterResetText.style.display = 'block';
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-reset-password-form', BrixResetPasswordForm.init);
}
